import React, { Component } from 'react';
import classes from './styles/PinnedMenu.scss';

export default class PinnedMenuDivider extends React.PureComponent {
    render() {
        return <hr className={classes.PinnedMenu__divider} />;
    }
}
